import { render, staticRenderFns } from "./SmReportFileIcon.vue?vue&type=template&id=0ee13fa9&scoped=true&"
var script = {}
import style0 from "./SmReportFileIcon.vue?vue&type=style&index=0&id=0ee13fa9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee13fa9",
  null
  
)

export default component.exports